import { useNavigate } from 'react-router';
import CasRouterTabs from 'src/compass/shared/components/CasTabsView/CasRouterTabs';
import { CasErrorDisplay, CasPage } from 'src/compass/shared/components';
import useRetrieve from 'src/compass/shared/hooks/reactQuery/useRetrieve';
import CasLoader from 'src/compass/shared/components/CasLoader/CasLoader';
import { useCurrentUserEmployee } from 'src/compass/application';

import CustomersTab from './_touchpoints/components/CustomersTab';
import TouchpointsTab from './_touchpoints/components/TouchpointsTab';
import HandoffsTab from './_touchpoints/components/HandoffsTab';
import UnassignedTab from './_touchpoints/components/UnassignedTab';

export const TabListEntityTouchpoints = {
  noDefault: false,
  tabs: [
    { label: 'Customers', children: <CustomersTab /> },
    { label: 'Touchpoints', children: <TouchpointsTab /> },
    { label: 'Handoffs', children: <HandoffsTab /> },
    { label: 'Unassigned', children: <UnassignedTab /> },
  ],
};

export default function CustomersPage() {
  const navigate = useNavigate();

  const {
    data: currentUserData,
    isLoading: currentUserLoading,
    isError: isCurrentUserError,
    error: currentUserError,
  } = useCurrentUserEmployee();

  const { isFetching, isError, error } = useRetrieve({
    url: 'Utilities/EntityTouchpoint/HasUnassignedEntity',
    params: { employeeId: currentUserData?.employeeId },
    enabled: !!currentUserData?.employeeId,
    onSuccess: (response: any) => {
      if (response.hasUnassigned)
        navigate('/riskManagement/customers/Unassigned', {
          state: { autoNavigated: true },
        });
      return response;
    },
  });

  if (currentUserLoading || isFetching) return <CasLoader />;
  if (isCurrentUserError || isError)
    return (
      <CasErrorDisplay
        message={currentUserError?.message || error?.message || 'An error occurred'}
      />
    );

  return (
    <CasPage title="Customers" pageTitle="Risk Management">
      <CasRouterTabs
        tabList={TabListEntityTouchpoints.tabs}
        baseUrl="/riskmanagement/customers"
      />
    </CasPage>
  );
}